module.exports = __webpack_public_path__ + "static/media/animated-1.a4efa9a4.gif";